module.exports = __webpack_public_path__ + "static/media/logo.a9474e0b.png";